const createColumnFilter = (api, thead, filterConfig) => {
  const filterRow = document.createElement('tr')

  api.columns().every(function (index) {
    const column = this
    const th = document.createElement('th')

    const filter = filterConfig.find((f) => f.index === index)

    if (filter) {
      if (filter.type === 'input') {
        const input = document.createElement('input')
        input.className = 'form-control form-control-sm'
        input.placeholder = filter.placeholder || ''
        input.style.width = '100%'

        input.addEventListener('keyup', function () {
          column.search(this.value).draw()
        })

        th.appendChild(input)
      } else if (filter.type === 'select') {
        const select = document.createElement('select')
        select.className = 'form-control form-control-sm'

        filter.options.forEach((option) => {
          const optionElement = document.createElement('option')
          optionElement.value = option.value
          optionElement.textContent = option.text
          select.appendChild(optionElement)
        })

        select.addEventListener('change', function () {
          if (this.value === '') {
            column.search('', false, false).draw()
          } else {
            column.search(`^${this.value}$`, true, false).draw()
          }
        })

        th.appendChild(select)
      }
    }

    filterRow.appendChild(th)

    return true
  })

  thead.appendChild(filterRow)
}

export { createColumnFilter }
